import type { ComponentType } from "react";
import { createBrowserRouter, createHashRouter, type RouteObject } from "react-router";
import { RootLayout } from "@/components/layout/RootLayout";
import { Splash } from "@/components/layout/Splash";
import { RouteError } from "@/routes/RouteError";
// Already in the entry chunk through RouteError, so not split out.
import NotFound from "@/routes/NotFound";

// Each page is its own chunk; the router waits for it before transitioning,
// so the outgoing page never flashes an empty state.
const page = (load: () => Promise<{ default: ComponentType }>) => async () => ({
  Component: (await load()).default,
});

const routes: RouteObject[] = [
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <RouteError />,
    hydrateFallbackElement: <Splash />,
    children: [
      { index: true, lazy: page(() => import("@/routes/Home")) },
      { path: "ventures", lazy: page(() => import("@/routes/Ventures")) },
      { path: "ventures/:slug", lazy: page(() => import("@/routes/Venture")) },
      { path: "house", lazy: page(() => import("@/routes/House")) },
      { path: "brand", lazy: page(() => import("@/routes/Brand")) },
      { path: "contact", lazy: page(() => import("@/routes/Contact")) },
      { path: "docs", lazy: page(() => import("@/routes/Docs")) },
      { path: "*", Component: NotFound },
    ],
  },
];

// Static hosts without rewrite rules (previews) build with VITE_ROUTER=hash.
export const router =
  import.meta.env.VITE_ROUTER === "hash" ? createHashRouter(routes) : createBrowserRouter(routes);
